import { lazy, Suspense, type ReactNode } from 'react';
import type { RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';
import { PageSkeleton } from '../../components/Page';

const OrdersPage = lazy(() => import('./pages/OrdersPage'));
const OrderDetailPage = lazy(() => import('./pages/OrderDetailPage'));
const ChargesPage = lazy(() => import('./pages/ChargesPage'));
const SalesHistoryPage = lazy(() => import('./pages/SalesHistoryPage'));
const ReceiptPage = lazy(() => import('./pages/ReceiptPage'));

/** Telas dentro do shell: esqueleto da página enquanto o código carrega (nada de tela branca). */
const S = ({ children, variant = 'list' }: { children: ReactNode; variant?: 'list' | 'dashboard' }) => (
  <Suspense fallback={<PageSkeleton variant={variant} />}>{children}</Suspense>
);

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  { path: 'pedidos', element: <S><OrdersPage /></S> },
  // Caminho fixo: vence o "pedidos/:id" e o "pedidos/cobrancas/*" provisório do menu.
  { path: 'pedidos/cobrancas', element: <S variant="dashboard"><ChargesPage /></S> },
  { path: 'pedidos/:id', element: <S><OrderDetailPage /></S> },
  { path: 'historico', element: <S><SalesHistoryPage /></S> },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [
  { path: 'recibo/:id', element: <Suspense fallback={<PageLoader />}><ReceiptPage /></Suspense> },
];
